export const errorCodeMessage = {
  '65_eventime': {
    TH: 'ไม่สามารถสตรีมสดได้ในขณะที่ยังไม่ถึงวันที่ไม่สามารถรับชมได้',
    EN: `The Livestream has not started. <br>Livestreams will be available on the date and time presented on the ticket.`,
  },
  64: {
    TH: 'ไม่สามารถสตรีมสดได้ในขณะที่ยังไม่ถึงวันที่ไม่สามารถรับชมได้',
    EN: 'The Livestream has not started. <br>Livestreams will be available on the date and time presented on the ticket.',
  },
  65: {
    TH: 'รหัสผู้เข้าร่วมอาจไม่ถูกต้อง',
    EN: 'Incorrect Entrance code. <br>Please check and try again.',
  },
  85: {
    TH: 'Param validation failed',
    EN: 'Param validation failed',
  },
}

export const getErrorMessage = (code, lang) => {
  let msg = ''
  switch (code) {
    case '65_eventime': {
      msg = errorCodeMessage[code][lang]
      break
    }
    case 64: {
      msg = errorCodeMessage[code][lang]
      break
    }
    case 65: {
      msg = errorCodeMessage[code][lang]
      break
    }
    case 85: {
      msg = errorCodeMessage[code][lang]
      break
    }
    default: {
      msg = `The entrant code maybe incorrect ${code}`
    }
  }
  return msg
}
